import {
  Inventory2Outlined,
  PersonAddAlt1Outlined,
  AutoGraphOutlined,
  PeopleAltOutlined,
  PercentOutlined,
  CardGiftcardOutlined,
} from '@mui/icons-material';

export const QuickLinkConfig = [
  {
    label: 'Inventory',
    key: 'inventory',
    path: '/inventory',
    icon: <Inventory2Outlined />,
    isVisible: true,
  },
  {
    label: 'Performance',
    key: 'network_performance',
    path: '/my-performance/network-performance',
    icon: <AutoGraphOutlined />,
    isVisible: true,
  },
  {
    label: 'My Rewards',
    key: 'my_rewards',
    path: '/benefits/rewards',
    icon: <CardGiftcardOutlined />,
    isVisible: true,
  },
  {
    label: 'Beneficiary',
    key: 'beneficiary',
    path: '/beneficiary',
    icon: <PeopleAltOutlined />,
    isVisible: true,
  },
  {
    label: 'Cumulative TDS',
    key: 'cumulative_tds',
    path: '/benefits/cumulative-tds',
    icon: <PercentOutlined />,
    isVisible: true,
  },
  {
    label: 'FAQ',
    key: 'faq',
    path: '/pwa-faq',
    icon: <PersonAddAlt1Outlined />,
    isVisible: true,
  },
  
];
